import React, { useEffect , useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import SimpleBar from "simplebar-react";
//import logo
import logoSm from "../assets/images/logo-sm-n.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.svg";

//Import Components
import VerticalLayout from "./VerticalLayouts";
import TwoColumnLayout from "./TwoColumnLayout";
import { Container, Button } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";
import config from "../config";

const Sidebar = ({ layoutType }) => {

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }   
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-sidebar-size", "sm");
    var appmenu = document.getElementsByClassName("app-menu");
    if (appmenu) {
      appmenu[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }  
  });


 
  

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };
      const [searchParams] = useSearchParams();
      const [logo_visibility, setlogo_visibility] = useState(true)
       useEffect(() => {
         
     
               if(searchParams.get('logo')){
              localStorage.setItem("logo",searchParams.get('logo'))
          }else{
              // if(!localStorage.getItem('logo')){
              //     localStorage.setItem("logo",true)
              // }else{
              //     localStorage.setItem("logo",false)
              // }
          }
          setlogo_visibility(localStorage.getItem('logo') =='true' || localStorage.getItem('logo')==undefined)
       }, [searchParams.get('logo')])


  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          {(logo_visibility && config.general_config.LOGO_VISIBILITY) && <><Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="30" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoLight} alt="" height="30" />
            </span>
          </Link></>}
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>
        <div className="close_mobile">
             <Button color="secondary" className="btn-icon" outline> <i className="ri-close-circle-line" /> </Button>
          </div>
         {/* {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === 'twocolumn' ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (  */}
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav" data-simplebar="init">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
                <div className="footer-bottom">
                  <p>
                  You agreed to the DBinsight.ai
                    <Link
                      to="/Terms_and_Conditions"
                      className="text-decoration-none fst-normal fw-medium"
                      style={{ paddingLeft: "5px" }}
                        target="_blank"
                    >
                      {" "}
                      Terms and Conditions
                    </Link> & <Link
                      to="/Privacy_and_Policy"
                      className="text-decoration-none fst-normal fw-medium"
                      style={{ paddingLeft: "5px" }}
                        target="_blank"
                    >
                      {" "}
                      Privacy and Policy
                    </Link>
                  </p>
                </div>
              </Container>
            </SimpleBar>
            <div className="sidebar-background"></div>
          </React.Fragment>
         {/* )}  */}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
